import { clamp } from '@antv/util';
import { isRealNumber } from '../../utils/number';

/**
 * è·åè¿åº¦æ¡æ°æ®
 */
export function getProgressData(percent: number) {
  const clampPercent = clamp(isRealNumber(percent) ? percent : 0, 0, 1);
  return [
    {
      type: 'current',
      percent: clampPercent,
    },
    {
      type: 'target',
      percent: 1 - clampPercent,
    },
  ];
}
